module.exports = __webpack_public_path__ + "img/icon-search.5f3aed6d.svg";